export default "__VITE_ASSET__136b07f0__"